import { render, staticRenderFns } from "./SendTermsOfService.vue?vue&type=template&id=ace15122&"
import script from "./SendTermsOfService.vue?vue&type=script&lang=js&"
export * from "./SendTermsOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace15122')) {
      api.createRecord('ace15122', component.options)
    } else {
      api.reload('ace15122', component.options)
    }
    module.hot.accept("./SendTermsOfService.vue?vue&type=template&id=ace15122&", function () {
      api.rerender('ace15122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SendTermsOfService.vue"
export default component.exports